import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./index.css";
import MainPage from "./Pages/MainPage";
import SignupPage from "./Pages/SignupPage";
import LoginPage from "./Pages/LoginPage";
import AdminKeywordsPage from "./Pages/admin/AdminKeywordsPage";
import ProtectedRoute from "./Components/ProtectedRoute";
import { AuthProvider } from "./Contexts/AuthContext";
import BlogDetailPage from "./Pages/BlogDetailPage";
import SallyNamecard from "./Pages/SallyNamecard"; // Import the new component

import IFrameLink from "./Components/IFrameLink";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/blog/:documentId" element={<BlogDetailPage />} />
          <Route path="/Sally_Namecard" element={<SallyNamecard />} /> {/* New route for Sally's namecard */}
          <Route path="/meeting" element={<IFrameLink title="Meet with Sally" link="https://kdz2ecuce1a.sg.larksuite.com/scheduler/59dd903ec6bea5ea"/>} />
          <Route path="/deck" element={<IFrameLink title="Genomii Deck" link="https://www.canva.com/design/DAGdvFdg1MY/KyPVlVibDD4w6VcU4TERNw/view?embed"/>} />
          <Route path="/app_deck" element={<IFrameLink title="Genomii Deck" link="https://www.canva.com/design/DAGdvFdg1MY/KyPVlVibDD4w6VcU4TERNw/view?embed"/>} />
          <Route
            path="/admin/keywords"
            element={
              <ProtectedRoute>
                <AdminKeywordsPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);